import Logo_ from './assets/logo.svg';
import LogoFull from './assets/logo-full.svg';
import LogoFullVertical from './assets/logo-full-vertical.svg';

type LogoVariants = 'iconOnly' | 'fullLogo' | 'fullLogoVertical';

type LogoProps = {
  variant?: LogoVariants;
  width?: string | number;
  height?: string | number;
};

const logoImg: Record<LogoVariants, any> = {
  iconOnly: Logo_,
  fullLogo: LogoFull,
  fullLogoVertical: LogoFullVertical,
};

export const Logo = ({ variant = 'iconOnly', width, height }: LogoProps) => {
  const style = {
    width,
    height,
  };

  return <img src={logoImg[variant]} style={style} alt="recovr logo" />;
};
